module.exports = __webpack_public_path__ + "static/media/2005 Belgrade, Serbia.8d113121.jpg";